import type React from 'react';
import AkomiLoginForm from 'src/AkomiLoginPage/AkomiLoginForm/AkomiLoginForm';
import useStyles from 'src/AkomiLoginPage/AkomiLoginPageStyles';
import Logo from 'src/components/logo';

const AkomiLoginPage: React.FC = () => {
  const classes = useStyles();
  return (
    <div className={classes.akomiLoginPage}>
      <div className={classes.akomiLoginLogo}>
        <Logo type="login" />
      </div>
      <div className={classes.akomiLoginForm}>
        <AkomiLoginForm />
      </div>
    </div>
  );
};

export default AkomiLoginPage;
